<template>
	<span ref="targetSpan" class="fit"><slot></slot></span>
</template>
<script>
import fitty from "fitty";
export default {
	name: "BestFitText",
	props: {
		min: 
        {
            type: Number,
            default: 10
		},
		max: 
        {
            type: Number,
            default: 28
		},
		options: {
			type: Object,
			required: false,
			default() {
				return {
					minSize: this.min,
					maxSize: this.max,
					multiLine: true
				};
			}
		}
	},
	data()
	{
		return {
			fit: {
				fitty: null,
				delay: false
			}
		}
	},
	mounted() 
	{
		this.$nextTick(()=>{
			if (this.$refs.targetSpan)
			{
				this.$set(this.fit, 'fitty', fitty(this.$refs.targetSpan, this.options))
			}
			else
			{
				this.$nextTick(()=>{
					if (this.$refs.targetSpan)
					{
						this.$set(this.fit, 'fitty', fitty(this.$refs.targetSpan, this.options))
					}
				});
			}
			if (this.fit.delay)
			{
				this.refresh();
				this.fit.delay = false;
			}
		});
	},
	destroyed()
	{
		// This should never be false, but just in case...
		if (this.fit.fitty)
		{
			this.fit.fitty.unsubscribe();
		}
		else
		{
			this.$nextTick(()=>{
				if (this.fit.fitty)
				{
					this.fit.fitty.unsubscribe();
				}
			})
		}
	},
	methods:
	{
		refresh()
		{
			// If it doesn't exist yet, no reason to fit it
			if (this.fit.fitty)
			{
				console.log('fitting');
				this.fit.fitty.fit();
				console.log('done');
			}
			else this.fit.delay = true;
		}
	}
};
</script>
<style lang="scss" scoped>
.fit {
	display: inline-block;
	white-space: normal !important;
	word-break: break-word;
	//line-height: 100% !important;
}
</style>